import PortalNavbar from "./components/PortalNavbar";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import CardFlow from "./components/CardFlow";
import BoardFeed from "./components/BoardFeed";
import RankBoard from "./components/RankBoard";
import Community from "./components/Community";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-sans">
      <PortalNavbar />
      <main>
        <Hero />
        <HotBoard />
        <CardFlow />
        <BoardFeed />
        <RankBoard />
        <Community />
      </main>
      <SiteFooter />
    </div>
  );
}